import React from 'react';
import { Link } from 'react-router-dom';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  withText?: boolean;
}

const Logo: React.FC<LogoProps> = ({ size = 'md', withText = true }) => {
  const sizeClasses = {
    sm: 'h-8',
    md: 'h-10',
    lg: 'h-12',
  };

  return (
    <Link 
      to="/" 
      className="flex items-center"
      aria-label="TLC International School - Go to homepage"
    >
      <div className="relative">
        <img 
          src="/images/logos/tlc-logo-small.webp" 
          alt="TLC International School Logo" 
          className={`${sizeClasses[size]} object-contain`}
          width="80"
          height="80"
          loading="eager"
        />
      </div>
      {withText && (
        <div className="ml-2 text-tlc-navy font-serif">
          <span className="font-bold">TLC</span>
          <span> International School</span>
        </div>
      )}
    </Link>
  );
};

export default Logo; 